<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        :disabled="mode === 1 ? !formValid : false"
        @cancel="$emit('cancel')"
        @submit="mode === 1 ? createPaymentMethod() : updatePaymentMethod()"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-row no-gutters>
            <v-col cols="12" class="pl-2">
                <b-text-field
                    v-model="paymentMethod.name"
                    label="Payment Method Name"
                    class="mb-4"
                ></b-text-field>
                <b-select
                    v-model="paymentMethod.system_payment_method_id"
                    :items="systemPaymentMethods"
                    item-text="title"
                    item-value="system_payment_method_id"
                    :label="translations.systemPaymentMethod[lang]"
                    no-top-margin
                    :success="success.system_payment_method"
                    :error-messages="error.system_payment_method"
                    @focus="error.system_payment_method = ''"
                    @blur="validateSystemPaymentMethod"
                    :disabled="mode == 2"
                ></b-select>
            </v-col>

            <v-col cols="12" class="pl-2 mt-4" v-if="showCredentials">
                <h3
                    class="subtitle-1 font-weight-bold"
                    v-text="translations.credentials[lang]"
                ></h3>

                <b-text-field
                    v-for="(field, key) in paymentMethod.credentials"
                    :key="key"
                    v-model="paymentMethod.credentials[key]"
                    :label="key"
                ></b-text-field>
            </v-col>
        </v-row>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import validators from "@/utils/validators/loyaltyPanel/subscriptions";
import translations from "@/utils/translations/loyaltyPanel/subscriptions/paymentMethods";

export default {
    name: "StoreForm",

    mixins: [validators, translations],

    props: {
        mode: Number,
    },

    data: () => ({
        showCredentials: false,
    }),

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),
        ...mapState("loyaltyPanel/subscriptions/paymentMethods", [
            "systemPaymentMethods",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 1
                ? this.translations.modalTitle1[this.lang]
                : this.translations.modalTitle2[this.lang];
        },

        paymentMethod: {
            get() {
                return this.$store.state.loyaltyPanel.subscriptions
                    .paymentMethods.paymentMethod;
            },
            set(val) {
                this.setPaymentMethod(val);
            },
        },
    },

    watch: {
        ["paymentMethod.system_payment_method_id"]: {
            immediate: true,
            handler(val) {
                if (this.mode == 1) {
                    if (val) {
                        let systemPaymentMethod =
                            this.systemPaymentMethods.find((item) => {
                                return item.system_payment_method_id == val;
                            });

                        systemPaymentMethod.fields.map((item) => {
                            this.paymentMethod.credentials[item] = "";
                        });
                        if (val == 1) {
                            this.showCredentials = false;
                        } else {
                            this.showCredentials = true;
                        }
                    }
                } else {
                    if (val == 1) {
                        this.showCredentials = false;
                    } else {
                        this.showCredentials = true;
                    }
                }
            },
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/subscriptions/paymentMethods", [
            "getSystemPaymentMethods",
            "createPaymentMethod",
            "updatePaymentMethod",
        ]),
        ...mapMutations("loyaltyPanel/subscriptions/paymentMethods", [
            "setPaymentMethod",
        ]),
    },

    mounted() {},
};
</script>
